import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getCustomer = async (params) => {
	const { data } = await axios.get(`${API}/admin/customer`, { params });
	return data;
};

export const saveCustomer = async (params) => {
	const { data } = await axios.post(`${API}/admin/customer/save`, params);
	return data;
};

export const deleteSeason = async (params) => {
	const { data } = await axios.post(`${API}/admin/customer/seasons/delete`, params);
	return data;
};

export const importExcel = async (formData) => {
	const { data } = await axios.post(`${API}/client/implementation/import_excel`, formData, {
		headers: { "Content-Type": "multipart/form-data" },
	});
	return data;
};

export const exportExcel = async () => {
	const { data } = await axios.get(`${API}/client/implementation/export_excel`);
	return data;
};
